import React from "react";

export default function EcoCalculatorPage() {
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 80px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "20px 20px 0" }}>
        <h1 className="text-2xl font-bold text-gray-800">
          Калькулятор экосбора РОП
        </h1>
      </div>

      <iframe
        src="/eco-calc/index.html"
        title="Калькулятор экосбора"
        style={{
          flex: 1,
          width: "100%",
          border: "none",
          backgroundColor: "#f5f7f9",
        }}
      />
    </div>
  );
}